var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "#00E676"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.9995 132.5H132.5V100H103.977V82.5H150V150H82.5005V100H82.4995V67.6709H82.4985V67.5H67.4985V82.5H79.0913V100H49.9995V50H99.9995V132.5Z",
    fill: "#121514"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bard.22e21cffccab5b74d01c3fe73d62fd80.svg";